import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

import { ControllerAddress } from './ControllerAddress'

const CustomControllerNamePropsSchema = z.object({
  name: z.string(),
  address: z.instanceof(ControllerAddress),
})

type CustomControllerNameProps = z.infer<typeof CustomControllerNamePropsSchema>

export class CustomControllerName extends ValueObject<CustomControllerNameProps> {
  public getName(): string {
    return this.props.name
  }

  public getAddress(): ControllerAddress {
    return this.props.address
  }

  public static create(props: CustomControllerNameProps): CustomControllerName {
    const validatedProps = CustomControllerNamePropsSchema.parse(props)
    return new CustomControllerName(validatedProps)
  }
}
